
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/passenger-car",
      function () {
        return require("private-next-pages/tyres/passenger-car.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/passenger-car"])
      });
    }
  